import { Resource } from 'store/resource/types';

export const getResourceTimezone = (resource: Resource, buildingTimezone: string): string => {
  return resource?.timezone ?? buildingTimezone;
};
